import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DisabledVisibleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"disabled_visible"}/>
}
